import { twMerge } from "tailwind-merge";
import { Type, TypeVariant } from "@themes/pollinator/ui/Type";

export type Props = {
  children?: React.ReactNode;
  id?: string;
  title?: string;
  description?: React.ReactNode;
  /** Typography variant for the title (default: "h4") */
  titleVariant?: TypeVariant;
  /** Typography variant for the description (default: "body2") */
  descriptionVariant?: TypeVariant;
  className?: string;
  /** Override the inner heading group's spacing (default: "gap-2") */
  headingClassName?: string;
};

/**
 * A section heading component with customizable title and description typography.
 * Can be used as a standalone heading or as a section wrapper with children.
 */
export function SectionHeading({
  children,
  id,
  title,
  description,
  titleVariant = "h3",
  descriptionVariant = "body2",
  className,
  headingClassName,
}: Props) {
  return (
    <div id={id} className={twMerge("flex flex-col gap-4 pb-12 border-b border-brand-200 last:border-b-0 md:gap-8 md:border-b-0 md:pb-0", className)}>
      {(title || description) && (
        <div className={twMerge("flex flex-col gap-2", headingClassName)}>
          {title && (
            <Type as="h2" variant={titleVariant}>
              {title}
            </Type>
          )}
          {description && (
            <Type as="p" variant={descriptionVariant}>
              {description}
            </Type>
          )}
        </div>
      )}
      {children}
    </div>
  );
}

export default SectionHeading;
